import { post } from './agent';

export default {
  create: (body) => post('/demo-request', body),
};
